import styled, { css } from 'styled-components';

interface IHetaryGroupProps {
  age_group:
  | '18'
  | '16'
  | '14'
  | '12'
  | '10'
  | 'L'
}

const colorVariations = {
  18: css`
    background: #191311;
    color: #fff;
  `,
  16: css`
    background: #e2332e;
    color: #fff;
  `,
  14: css`
    background: #ee772d;
    color: #fff;
  `,
  12: css`
    background: #fab02b;
    color: #fff;
  `,
  10: css`
    background: #5ba0bd;
    color: #fff;
  `,
  L: css`
    background: #32a540;
    color: #fff;
  `,
};

export const Container = styled.main<IHetaryGroupProps>`
  ${props => colorVariations[props.age_group]}
  font-size: 12px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: .5rem;
  height: 22px;
  width: 22px;
  font-weight: bold;
`;
